__turbopack_context__.v({
  "blink": "SideText-module-scss-module__3YtTSq__blink",
  "borderTop": "SideText-module-scss-module__3YtTSq__borderTop",
  "footnotes": "SideText-module-scss-module__3YtTSq__footnotes",
  "gallery": "SideText-module-scss-module__3YtTSq__gallery",
  "image": "SideText-module-scss-module__3YtTSq__image",
  "noFootnotes": "SideText-module-scss-module__3YtTSq__noFootnotes",
  "sideText": "SideText-module-scss-module__3YtTSq__sideText",
  "text": "SideText-module-scss-module__3YtTSq__text",
});
